import { render, staticRenderFns } from "./modalCotizarEnvioTodos.vue?vue&type=template&id=94881494&scoped=true&"
import script from "./modalCotizarEnvioTodos.vue?vue&type=script&lang=js&"
export * from "./modalCotizarEnvioTodos.vue?vue&type=script&lang=js&"
import style0 from "./modalCotizarEnvioTodos.vue?vue&type=style&index=0&id=94881494&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "94881494",
  null
  
)

export default component.exports